import { Link } from 'react-router-dom';
import { Row, Col, Divider, Icon } from 'antd';
import { getPortalData } from '@bit/ui-common.ui-components/ss-common-data/utils/helpUtils';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ setEnvPrefix } = ssCommonUtils, 
layoutFooterDividerLg = { position: 'absolute', width: '100%', left: '0px', top: '14px' },
layoutFooterDividerMd = { position: 'absolute', width: '100%', left: '0px', top: '4px' },
layoutFooterDividerSm = { position: 'absolute', width: '100%', left: '0px', top: '0px' },
layoutFooterDividerXs = { position: 'absolute', width: '100%', left: '0px', top: '0px' };

class Links extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div>
                <a href='https://www.tsa.gov/' target='_blank'>
                    {'Transportation Security Administration'}
                </a>
                <Divider type='vertical' />
                <a href='https://www.tsa.gov/privacy-policy' target='_blank'>
                    {'Terms of Use / Privacy Policy'}
                </a>{'   '}
                <Divider type='vertical' />
                <Link to={setEnvPrefix('/home/paperworkreductionact')}>
                    {'Paperwork Reduction Act'}
                </Link>{'   '}
                <Divider type='vertical' />
                <Link to={setEnvPrefix('/home/privacyactstatement')}>
                    {'Privacy Act Statement'}
                </Link>
            </div>
        )
    }
}

class Pdf extends React.Component {
    constructor(props) { super(props); }
    render = () => (
        <div>
            {'Some links on this page may require a browser plug-in, available here:  '}
            <Icon type='file-pdf' />
            <a href={setEnvPrefix("/home/warning?url=") + encodeURIComponent('http://get.adobe.com/reader/')} target='_blank'>
                {' Adobe Acrobat (PDF)'}
            </a>
        </div>
    );
}

class Notice extends React.Component {
    constructor(props) { super(props); }

    getMaintenancePeriod() {
        var maintenancePeriod = this.props.notice == null ? "" : this.props.notice.find(x => x.textDescription === "FTSP Maintenance Periods");
        return (maintenancePeriod == "" || maintenancePeriod == undefined) ? "" : maintenancePeriod;
    }
    
    render() {
        var maintenancePeriod = this.getMaintenancePeriod();
        return (
            <div>
                {'This online portal may be unavailable during the following scheduled maintenance periods: '}
                <i>{maintenancePeriod !== "" ? maintenancePeriod.text : "No maintenace periods specified"}</i>
            </div>
        )
    }
}

export default class AfspFooter extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { size, state } = this.props;
        const { FOOTER } = state.commonData.textData.textDataStore;
        switch(size) {
            case 'na': return null;
            case 'lg':
                return (
                    <div>
                        <Row style={{ marginTop: '-16px', textAlign: 'center' }}>
                            <Col span={24}>
                                <Links />
                            </Col>
                        </Row>
                        <Divider type='horizontal' style={layoutFooterDividerLg} />
                        <Row>
                            <Col span={24} style={{ marginTop: '19px' }}>
                                <Pdf />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Notice notice={getPortalData(FOOTER, 'c')}/>
                            </Col>
                        </Row>
                    </div>
                );
            case 'md': return (
                <div style={{ fontSize: '11px' }}>
                    <Row style={{ marginTop: '-18px', textAlign: 'center' }}>
                        <Col span={24}>
                            <Links />
                        </Col>
                    </Row>
                    <Divider type='horizontal' style={layoutFooterDividerMd} />
                    <Row>
                        <Col span={24} style={{ marginTop: '18px' }}>
                            <Pdf />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <Notice notice={getPortalData(FOOTER, 'c')}/>
                        </Col>
                    </Row>
                </div>
            );

            case 'sm': return (
                <div style={{ fontSize: '11px' }}>
                    <Row style={{ marginTop: '-20px', textAlign: 'center' }}>
                        <Col span={24}>
                            <Links />
                        </Col>
                    </Row>
                    <Divider type='horizontal' style={layoutFooterDividerSm} />
                    <Row style={{ fontSize: '9px' }}>
                        <Col span={10} style={{ marginTop: '17px' }}>
                            <Pdf />
                        </Col>
                        <Col span={14} style={{ marginTop: '17px', textAlign: 'right' }}>
                            <Notice notice={getPortalData(FOOTER, 'c')}/>
                        </Col>
                    </Row>
                </div>
            );

            case 'xs': return (
                <div style={{ fontSize: '11px' }}>
                    <Row style={{ marginTop: '-20px', textAlign: 'center' }}>
                        <Col span={24}>
                            <Links />
                        </Col>
                    </Row>
                    <Divider type='horizontal' style={layoutFooterDividerXs} />
                    <Row style={{ fontSize: '9px' }}>
                        <Col span={10} style={{ marginTop: '11px' }}>
                            <Pdf />
                        </Col>
                        <Col span={14} style={{ marginTop: '11px', textAlign: 'right' }}>
                            <Notice notice={getPortalData(FOOTER, 'c')}/>
                        </Col>
                    </Row>
                </div>
            );

            default: return null;
        }
    }
}
